/* FadCloset — builder.js
   Drives the custom order builder (category → design → fit → measurements)
   and the live cut ticket. */
(function () {
  'use strict';

  var form = document.querySelector('[data-builder]');
  if (!form) return;

  var categoryInputs = Array.prototype.slice.call(form.querySelectorAll('[data-category]'));
  var genderMenLabel = form.querySelector('[data-gender-option="Men\'s"]');
  var baseTilesBox = form.querySelector('[data-base-tiles]');
  var baseEmptyEl = form.querySelector('[data-base-empty]');

  var REQUIRED = 0; // always the full measurement count for the active category — set by setCategory()

  var idInput = form.querySelector('[data-variant-id]');
  var leatherSelect = form.querySelector('[data-leather]');
  var priceEl = form.querySelector('[data-price]');
  var priceLabel = form.querySelector('[data-price-label]');
  var quoteLine = form.querySelector('[data-quote-line]');
  var submit = form.querySelector('[data-submit]');
  var errorEl = form.querySelector('[data-error]');
  var progress = form.querySelector('[data-progress]');
  var serialEl = document.querySelector('[data-ticket-serial]');
  var measuresBox = document.querySelector('[data-ticket-measures]');
  var consent = form.querySelector('[data-consent]');

  var propBase = form.querySelector('[data-prop-base]');
  var propCutFor = form.querySelector('[data-prop-cutfor]');
  var propCategory = form.querySelector('[data-prop-category]');
  var propSpec = form.querySelector('[data-prop-spec]');

  var colorInput = form.querySelector('[data-color-input]');
  var colorHex = form.querySelector('[data-color-hex]');
  var eyedropperBtn = form.querySelector('[data-eyedropper]');

  var profileInputs = Array.prototype.slice.call(form.querySelectorAll('[data-q]'));
  var measureInputs = []; // scoped to the current category's panel — set by setCategory()

  var BASES = []; // the current category+gender's base-style products
  var basesData = {}; // "category|gender" -> array, parsed once from the inlined JSON blocks
  Array.prototype.forEach.call(document.querySelectorAll('[data-bases-json]'), function (script) {
    var key = script.dataset.category + '|' + script.dataset.gender;
    try { basesData[key] = JSON.parse(script.textContent); } catch (e) { basesData[key] = []; }
  });

  var currentCategory = form.dataset.defaultCategory || (categoryInputs[0] && categoryInputs[0].value) || 'jacket';

  var SPEC_KEY = 'fadcloset:spec';

  function readSaved() {
    try { return JSON.parse(localStorage.getItem(SPEC_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function writeSaved() {
    var spec = { category: currentCategory, measures: {}, profile: {}, savedAt: Date.now() };
    measureInputs.forEach(function (i) { if (i.value) spec.measures[i.dataset.num] = i.value; });
    profileInputs.forEach(function (q) {
      if (q.type === 'radio') { if (q.checked) spec.profile[q.dataset.label] = q.value; }
      else if (q.value) { spec.profile[q.dataset.label] = q.value; }
    });
    try { localStorage.setItem(SPEC_KEY, JSON.stringify(spec)); } catch (e) { /* private mode */ }
  }

  /* ---------- serial: a real, stable ticket number ---------- */
  var serial = 'FC-' + Date.now().toString(36).slice(-5).toUpperCase();
  if (serialEl) serialEl.textContent = serial;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function setTicket(key, value) {
    var el = document.querySelector('[data-ticket="' + key + '"]');
    if (!el) return;
    var filled = value && value !== '';
    el.textContent = filled ? value : '—';
    el.classList.toggle('is-empty', !filled);
  }

  function categoryLabel(slug) {
    var input = categoryInputs.find(function (c) { return c.value === slug; });
    var tile = input && input.closest('.tile');
    var labelEl = tile && tile.querySelector('.tile__label');
    return labelEl ? labelEl.textContent : slug;
  }

  function currentGender() {
    var checked = form.querySelector('[data-cut-for]:checked');
    return checked ? checked.value : "Men's";
  }

  /* ---------- fit differential note (from the FadCloset measurement guide) ---------- */
  var FIT_DIFFERENTIALS = {
    "Men's": {
      Slim: { chest: 2.0, waist: 4.0 },
      Regular: { chest: 3.0, waist: 5.0 },
      Loose: { chest: 4.5, waist: 6.5 }
    },
    "Women's": {
      Slim: { bust: 2.0, waist: 3.0, hips: 1.0 },
      Regular: { bust: 3.0, waist: 4.0, hips: 1.0 },
      Loose: { bust: 4.0, waist: 5.0, hips: 2.0 }
    }
  };

  /* Lower-body categories: the cut-room ease is the same for men and women, so it
     is keyed by category + fit rather than gender. Values are the upper end of
     each range in the FAD size guide. Skirt is women-only (locked by its setting). */
  var LOWER_BODY_EASE = {
    pants: {
      Slim:    [['waist', 1.0], ['hip', 1.5], ['thigh', 1.25], ['knee', 0.75]],
      Regular: [['waist', 1.5], ['hip', 2.0], ['thigh', 2.0], ['knee', 1.25]],
      Loose:   [['waist', 2.0], ['hip', 4.0], ['thigh', 3.5], ['knee', 3.0]]
    },
    shorts: {
      Slim:    [['waist', 1.0], ['hip', 1.5], ['thigh', 1.25]],
      Regular: [['waist', 1.5], ['hip', 2.0], ['thigh', 2.0]],
      Loose:   [['waist', 2.0], ['hip', 4.0], ['thigh', 3.5]]
    },
    skirt: {
      Slim:    [['waist', 1.0], ['hip', 1.5]],
      Regular: [['waist', 1.5], ['hip', 2.0]],
      Loose:   [['waist', 1.5], ['hip', 3.0]]
    }
  };

  function joinParts(parts) {
    if (parts.length < 2) return parts.join('');
    if (parts.length === 2) return parts.join(' and ');
    return parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1];
  }

  function fitNoteText(gender, fit, category) {
    var lower = LOWER_BODY_EASE[category] && LOWER_BODY_EASE[category][fit];
    if (lower) {
      var parts = [];
      for (var i = 0; i < lower.length; i++) {
        parts.push(lower[i][1] + '" at the ' + lower[i][0]);
      }
      return fit + ' fit adds ' + joinParts(parts) + ' over your body measurements — so measure snug, with no wiggle room.';
    }
    var d = FIT_DIFFERENTIALS[gender] && FIT_DIFFERENTIALS[gender][fit];
    if (!d) return '';
    if (gender === "Women's") {
      return fit + ' fit adds ' + d.bust + '" at the bust, ' + d.waist + '" at the waist, and ' + d.hips + '" at the hips over your body measurements — so measure snug, with no wiggle room.';
    }
    return fit + ' fit adds ' + d.chest + '" at the chest and ' + d.waist + '" at the waist over your body measurements — so measure snug, with no wiggle room.';
  }

  function updateFitNote() {
    var noteEl = document.querySelector('[data-fit-note]');
    if (!noteEl) return;
    var fitChecked = form.querySelector('[data-label="Preferred fit"]:checked');
    var fit = fitChecked ? fitChecked.value : 'Regular';
    var text = fitNoteText(currentGender(), fit, currentCategory);
    if (text) noteEl.textContent = text;
  }

  /* ---------- chest/bust build: same block, gender-appropriate label + property key ---------- */
  function updateChestLabel() {
    var block = form.querySelector('[data-chest-block]');
    if (!block) return;
    var isWomens = currentGender() === "Women's";
    var text = isWomens ? block.dataset.labelWomens : block.dataset.labelMens;

    var labelEl = block.querySelector('[data-chest-label]');
    if (labelEl) labelEl.textContent = text;

    var radios = block.querySelectorAll('[data-chest-radio]');
    Array.prototype.forEach.call(radios, function (r) {
      r.name = 'properties[' + text + ']';
      r.dataset.label = text;
    });
  }

  /* ---------- fit-profile tile photos: swap to the Women's set ---------- */
  function updateFitProfileImages() {
    var isWomens = currentGender() === "Women's";
    var imgs = form.querySelectorAll('[data-fit-gender-img]');
    Array.prototype.forEach.call(imgs, function (img) {
      var src = isWomens ? img.dataset.srcWomens : img.dataset.srcMens;
      if (!src) return;
      if (!img.dataset.fallbackBound) {
        img.dataset.fallbackBound = 'true';
        img.addEventListener('error', function () {
          if (img.src !== img.dataset.srcMens) img.src = img.dataset.srcMens;
        });
      }
      if (img.src !== src) img.src = src;
    });
  }

  /* ---------- core body "Full chest" -> "Full bust" for Women's ---------- */
  function updateCoreChestLabel() {
    var input = measureInputs.find(function (i) { return i.dataset.short === 'CHEST'; });
    if (!input) return;
    var isWomens = currentGender() === "Women's";
    var text = isWomens ? 'Full bust' : 'Full chest';

    var wrap = input.closest('.measure');
    var nameEl = wrap && wrap.querySelector('[data-measure-name]');
    if (nameEl) nameEl.textContent = text;

    input.name = 'properties[' + input.dataset.num + '. ' + text + ']';
    input.dataset.label = text;
  }

  /* ---------- base style -> leather variants -> price ---------- */
  function currentBase() {
    var checked = form.querySelector('[data-base]:checked');
    if (!checked) return null;
    return BASES.find(function (b) { return b.handle === checked.dataset.productHandle; }) || null;
  }

  function buildBaseTiles() {
    var list = basesData[currentCategory + '|' + currentGender()] || [];
    BASES = list;
    if (baseTilesBox) baseTilesBox.innerHTML = '';

    if (!list.length) {
      if (baseEmptyEl) baseEmptyEl.hidden = false;
      fillLeather();
      return;
    }
    if (baseEmptyEl) baseEmptyEl.hidden = true;

    if (list.length === 1 || !baseTilesBox) {
      var only = document.createElement('input');
      only.type = 'radio';
      only.name = 'baseStyle';
      only.hidden = true;
      only.checked = true;
      only.setAttribute('data-base', '');
      only.dataset.productHandle = list[0].handle;
      only.value = list[0].title;
      if (baseTilesBox) baseTilesBox.appendChild(only);
      fillLeather();
      return;
    }

    list.forEach(function (p, i) {
      var label = document.createElement('label');
      label.className = 'tile';
      var media = p.featuredImage
        ? '<img src="' + p.featuredImage + '" loading="lazy" alt="">'
        : 'photo';
      label.innerHTML =
        '<input type="radio" name="baseStyle" value="' + String(p.title).replace(/"/g, '&quot;') + '" data-base data-product-handle="' + p.handle + '"' + (i === 0 ? ' checked' : '') + '>' +
        '<span class="tile__media">' + media + '</span>' +
        '<span class="tile__label">' + p.title + '</span>';
      baseTilesBox.appendChild(label);
    });
    fillLeather();
  }

  function fillLeather() {
    var base = currentBase();
    leatherSelect.innerHTML = '';

    if (!base) {
      leatherSelect.innerHTML = '<option value="">Select a base style first</option>';
      idInput.value = '';
      priceEl.textContent = '—';
      priceLabel.textContent = 'Select a base style';
      setTicket('base', '');
      setTicket('leather', '');
      return;
    }

    base.variants.forEach(function (v, i) {
      var opt = document.createElement('option');
      opt.value = v.title;
      opt.dataset.variantId = v.id;
      opt.dataset.price = v.price;
      opt.textContent = v.title + (v.available ? '' : ' — currently unavailable');
      opt.disabled = !v.available;
      if (i === 0 && v.available) opt.selected = true;
      leatherSelect.appendChild(opt);
    });

    if (propBase) propBase.value = base.title;
    setTicket('base', base.title);
    syncVariant();
  }

  function syncVariant() {
    var opt = leatherSelect.options[leatherSelect.selectedIndex];
    if (!opt || !opt.dataset.variantId) {
      idInput.value = '';
      priceEl.textContent = '—';
      priceEl.classList.remove('is-pending');
      priceLabel.textContent = 'Select a base style';
      setTicket('leather', '');
      return;
    }
    idInput.value = opt.dataset.variantId;
    priceLabel.textContent = 'Made to measure';
    var cents = parseInt(opt.dataset.price, 10) || 0;
    if (cents > 0) {
      priceEl.textContent = money(cents);
      priceEl.classList.remove('is-pending');
    } else {
      // No price set on the variant — this is a quote request, not a pay-now order
      priceEl.textContent = 'Quoted after review';
      priceEl.classList.add('is-pending');
    }
    // Only attach the "Final price" line item note on unpriced (quote-request) variants
    if (quoteLine) quoteLine.disabled = cents > 0;
    setTicket('leather', opt.value);
  }

  /* ---------- category switching ---------- */
  function rebuildTicketMeasures() {
    measuresBox.innerHTML = '';
    measureInputs.forEach(function (input) {
      var cell = document.createElement('div');
      cell.className = 'ticket__m';
      cell.dataset.for = input.id;
      cell.innerHTML = '<span>' + input.dataset.short + '</span><b>—</b>';
      measuresBox.appendChild(cell);
    });
  }

  function setCategory(cat) {
    currentCategory = cat;
    if (propCategory) propCategory.value = categoryLabel(cat);
    setTicket('category', categoryLabel(cat));

    document.querySelectorAll('[data-measure-category]').forEach(function (panel) {
      panel.hidden = panel.dataset.measureCategory !== cat;
    });
    measureInputs = Array.prototype.slice.call(
      form.querySelectorAll('[data-measure-category="' + cat + '"] [data-measure-input]')
    );
    REQUIRED = measureInputs.length;

    var input = categoryInputs.find(function (c) { return c.value === cat; });
    var womenOnly = input && input.dataset.womenOnly === 'true';
    if (genderMenLabel) genderMenLabel.hidden = !!womenOnly;
    if (womenOnly) {
      var womensInput = form.querySelector('[data-cut-for][value="Women\'s"]');
      if (womensInput) womensInput.checked = true;
      if (propCutFor) propCutFor.value = "Women's";
      setTicket('cutFor', "Women's");
    }

    rebuildTicketMeasures();
    buildBaseTiles();
    updateCoreChestLabel();
    updateFitNote();
  }

  /* ---------- validation and progress ---------- */
  function filledCount() {
    return measureInputs.filter(function (i) { return i.value !== '' && i.checkValidity(); }).length;
  }

  function advisories() {
    var notes = [];
    var get = function (code) {
      var f = measureInputs.find(function (i) { return i.dataset.short === code; });
      return f && f.value ? parseFloat(f.value) : null;
    };

    var slvR = get('SLV R'), slvL = get('SLV L');
    if (slvR && slvL && Math.abs(slvR - slvL) > 2) {
      notes.push('Sleeves differ by more than 2 inches — worth re-checking.');
    }

    var chest = get('CHEST') || get('BUST'), waist = get('WAIST');
    if (chest && waist && waist > chest + 12) {
      notes.push('Waist is much larger than chest — re-check the tape is level.');
    }

    var shoulder = get('SHLDR'), hsR = get('HS R'), hsL = get('HS L');
    if (shoulder && hsR && hsL && Math.abs(shoulder - (hsR + hsL)) > 2) {
      notes.push('Half shoulders do not add up to the full shoulder width.');
    }

    var waistLower = get('WAIST'), hips = get('HIPS');
    if (waistLower && hips && waistLower > hips + 6) {
      notes.push('Waist is much larger than hips — worth re-checking.');
    }

    return notes;
  }

  function buildSpec() {
    var lines = [serial, 'Category: ' + categoryLabel(currentCategory), 'Cut for: ' + (propCutFor ? propCutFor.value : '')];
    var base = currentBase();
    if (base) lines.push('Base: ' + base.title);
    lines.push('Leather: ' + (leatherSelect.value || '—'));
    measureInputs.forEach(function (i) {
      if (i.value) lines.push(i.dataset.num + '.' + i.dataset.short + '=' + i.value);
    });
    return lines.join(' | ');
  }

  function refresh() {
    var done = filledCount();
    var pct = Math.min(100, Math.round((done / REQUIRED) * 100));
    if (progress) progress.style.width = pct + '%';

    measureInputs.forEach(function (i) {
      var cell = measuresBox.querySelector('[data-for="' + i.id + '"]');
      if (!cell) return;
      var ok = i.value !== '' && i.checkValidity();
      cell.querySelector('b').textContent = ok ? i.value : '—';
      cell.classList.toggle('is-filled', ok);
    });

    var photos = form.querySelectorAll('[data-upload]');
    var got = Array.prototype.filter.call(photos, function (p) { return p.files.length; }).length;
    setTicket('photos', got + ' of 3');

    var requiredPhotos = Array.prototype.slice.call(form.querySelectorAll('[data-photo-required]'));
    var photosFilled = requiredPhotos.every(function (p) { return p.files.length > 0; });

    var h = form.querySelector('#b-height');
    var w = form.querySelector('#b-weight');
    if (h || w) {
      var hw = [h && h.value, w && w.value].filter(Boolean).join(' · ');
      setTicket('hw', hw);
    }

    if (propSpec) propSpec.value = buildSpec();
    writeSaved();

    var profileInputs = Array.prototype.slice.call(form.querySelectorAll('[data-profile-required]'));
    var profileFilled = profileInputs.every(function (i) { return i.value.trim() !== ''; });

    var coreInputs = measureInputs.filter(function (i) { return i.hasAttribute('data-core-required'); });
    var coreFilled = coreInputs.every(function (i) { return i.value !== '' && i.checkValidity(); });

    var ready = idInput.value !== '' && photosFilled && done >= REQUIRED && coreFilled && profileFilled && consent.checked;
    submit.disabled = !ready;

    var notes = advisories();
    if (notes.length) {
      errorEl.textContent = 'Check: ' + notes[0];
      errorEl.classList.add('is-shown');
    } else if (idInput.value === '') {
      errorEl.textContent = 'Select a base style and leather';
      errorEl.classList.add('is-shown');
    } else if (!photosFilled) {
      errorEl.textContent = 'Upload a front and back reference photo';
      errorEl.classList.add('is-shown');
    } else if (!coreFilled) {
      errorEl.textContent = 'Fill in your core body measurements';
      errorEl.classList.add('is-shown');
    } else if (!profileFilled && done >= REQUIRED) {
      errorEl.textContent = 'Fill in your fit profile above';
      errorEl.classList.add('is-shown');
    } else if (!ready && done > 0) {
      var left = REQUIRED - done;
      errorEl.textContent = left > 0
        ? left + ' measurement' + (left === 1 ? '' : 's') + ' left'
        : 'Tick the confirmation to continue';
      errorEl.classList.add('is-shown');
    } else {
      errorEl.classList.remove('is-shown');
    }
  }

  /* ---------- events ---------- */
  form.addEventListener('change', function (e) {
    var t = e.target;

    if (t.matches('[data-category]')) setCategory(t.value);
    if (t.matches('[data-base]')) fillLeather();
    if (t === leatherSelect) syncVariant();

    if (t.matches('[data-cut-for]')) {
      if (propCutFor) propCutFor.value = t.value;
      setTicket('cutFor', t.value);
      buildBaseTiles();
      updateFitNote();
      updateChestLabel();
      updateCoreChestLabel();
      updateFitProfileImages();
    }

    if (t.matches('[data-prop-radio]') || t.matches('[data-prop-simple]')) {
      var key = (t.name.match(/properties\[(.+)\]/) || [])[1];
      if (key) setTicket(key, t.value);
      if (t.dataset.label === 'Preferred fit') updateFitNote();
    }

    if (t.matches('[data-upload]')) {
      var nameEl = t.parentElement.querySelector('[data-upload-name]');
      if (nameEl) {
        if (!t.files.length) {
          nameEl.textContent = '';
        } else if (t.files.length === 1) {
          nameEl.textContent = t.files[0].name;
        } else {
          nameEl.textContent = t.files.length + ' photos selected';
        }
      }

      var multiPreviewEl = t.parentElement.querySelector('[data-upload-preview-multi]');
      if (multiPreviewEl) {
        while (multiPreviewEl.firstChild) multiPreviewEl.removeChild(multiPreviewEl.firstChild);
        if (t.files.length) {
          Array.prototype.forEach.call(t.files, function (file) {
            var img = document.createElement('img');
            img.src = URL.createObjectURL(file);
            img.alt = '';
            multiPreviewEl.appendChild(img);
          });
          multiPreviewEl.hidden = false;
        } else {
          multiPreviewEl.hidden = true;
        }
      } else {
        var previewEl = t.parentElement.querySelector('[data-upload-preview]');
        if (previewEl) {
          if (t.files.length) {
            previewEl.src = URL.createObjectURL(t.files[0]);
            previewEl.hidden = false;
          } else {
            previewEl.hidden = true;
          }
        }
      }
    }

    if (t === colorInput) updateColorHex();

    refresh();
  });

  form.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-prop-simple]')) {
      var key = (t.name.match(/properties\[(.+)\]/) || [])[1];
      if (key) setTicket(key, t.value);
    }
    if (t === colorInput) updateColorHex();
    if (t.matches('[data-measure-input]') || t.matches('[data-prop-simple]')) refresh();
  });

  /* ---------- color: wheel + eyedropper sampling ---------- */
  function updateColorHex() {
    if (colorInput && colorHex) colorHex.textContent = colorInput.value.toUpperCase();
  }

  if (eyedropperBtn && window.EyeDropper) {
    eyedropperBtn.hidden = false;
    eyedropperBtn.addEventListener('click', function () {
      new window.EyeDropper().open().then(function (result) {
        colorInput.value = result.sRGBHex;
        updateColorHex();
        setTicket('Color', result.sRGBHex);
        refresh();
      }).catch(function () { /* user cancelled */ });
    });
  }

  // Measurement help text
  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-help]');
    if (!btn) return;
    var wrap = btn.closest('[data-measure]');
    var open = wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- submit ---------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submit.disabled) return;

    submit.disabled = true;
    var label = submit.textContent;
    submit.textContent = 'Submitting your request…';

    var data = new FormData(form);
    // Internal-only fields we do not want on the customer's line item
    data.delete('category');
    data.delete('baseStyle');
    data.delete('cutFor');
    data.delete('properties[__leather_display]');
    data.append('properties[Leather]', leatherSelect.value);
    data.append('properties[Cut ticket]', serial);

    // Multi-file uploads (Details) — give each file its own property so the cart keeps them all
    var multiUpload = form.querySelector('[data-upload-multi]');
    if (multiUpload && multiUpload.files.length) {
      data.delete(multiUpload.name);
      Array.prototype.forEach.call(multiUpload.files, function (file, i) {
        data.append('properties[Detail view ' + (i + 1) + ']', file);
      });
    }

    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.text().then(function (t) {
          var body;
          try { body = JSON.parse(t); }
          catch (e) {
            throw new Error('Could not reach the cart. Open this page in a normal browser tab (not the theme editor) and try again.');
          }
          return { ok: r.ok, body: body };
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'We could not submit this request.');
        if (typeof gtag === 'function') {
          gtag('event', 'conversion', { send_to: 'AW-867418672/lZVyCLynufUcELCEz50D' });
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        errorEl.textContent = err.message;
        errorEl.classList.add('is-shown');
        submit.textContent = label;
        submit.disabled = false;
      });
  });

  /* ---------- init ---------- */
  var params = new URLSearchParams(window.location.search);
  var saved = readSaved();

  var wantedCategory = params.get('category');
  if (wantedCategory && categoryInputs.some(function (c) { return c.value === wantedCategory; })) {
    currentCategory = wantedCategory;
  } else if (saved.category && categoryInputs.some(function (c) { return c.value === saved.category; })) {
    currentCategory = saved.category;
  }
  categoryInputs.forEach(function (c) { c.checked = (c.value === currentCategory); });

  setCategory(currentCategory);

  // Restore saved measurements and profile answers now that the right panel is showing
  measureInputs.forEach(function (i) {
    var v = saved.measures && saved.measures[i.dataset.num];
    if (v) i.value = v;
  });
  profileInputs.forEach(function (q) {
    var v = saved.profile && saved.profile[q.dataset.label];
    if (!v) return;
    if (q.type === 'radio') { if (q.value === v) q.checked = true; }
    else { q.value = v; }
  });
  profileInputs.forEach(function (q) {
    if (q.type === 'radio' ? q.checked : q.value) {
      var key = (q.name.match(/properties\[(.+)\]/) || [])[1];
      if (key) setTicket(key, q.value);
    }
  });

  // Deep link from a sold-out size on a regular product page
  var wantedStyle = params.get('style');
  if (wantedStyle) {
    var tile = form.querySelector('[data-base][data-product-handle="' + wantedStyle + '"]');
    if (tile) { tile.checked = true; fillLeather(); }
  }

  updateColorHex();
  updateFitNote();
  updateChestLabel();
  updateCoreChestLabel();
  updateFitProfileImages();
  refresh();

  // Arriving from the guide with a full sheet — say so rather than leaving them to notice
  if (params.get('spec') === 'saved' && filledCount() > 0) {
    errorEl.textContent = 'Your measurements from the guide are filled in below.';
    errorEl.classList.add('is-shown');
  }
})();
